import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <>
      <footer className="main-footer">
        <strong>
        Software Developed By <Link to="/">Smart Field Service</Link>.&nbsp;
        </strong>
       
        <div className="float-right d-none d-sm-inline-block"></div>
      </footer>
    </>
  );
}
